import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryCards from './components/CategoryCards';
import SeoContentSection from './components/SeoContentSection';
import ArticleCardsSection from './components/ArticleCardsSection';
import ComparisonTable from './components/ComparisonTable';
import TrustSection from './components/TrustSection';
import { getSiteUrl } from '@/utils/seo';

const websiteJsonLd = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Basetao Spreadsheet Resource Hub',
  url: getSiteUrl(),
  description: 'The ultimate Basetao Spreadsheet resource hub featuring product guides, reviews, shipping cost information, warehouse tips, coupons, and expert buying strategies.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${getSiteUrl()}/search?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
});

const breadcrumbJsonLd = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: getSiteUrl(),
    },
  ],
});

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: websiteJsonLd }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: breadcrumbJsonLd }}
      />
      <Navbar />
      <HeroSection />
      <CategoryDropdown />
      <CategoryCards />
      <SeoContentSection />
      <ArticleCardsSection />
      <ComparisonTable />
      <TrustSection />
      <Footer />
    </main>
  );
}